import React from 'react';
import { Boxes } from 'lucide-react';
import { packOptions } from '../services/stock';
import { useT } from '../services/i18n';

// Product page: choose unit or a pack (carton, lot…)
const PackSelector = ({ product, selected, onSelect, available }) => {
  const { t } = useT();
  const options = packOptions(product);
  if (options.length <= 1) return null;
  return (
    <div className="mt-6" data-testid="pack-selector">
      <p className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2"><Boxes size={16} className="text-orange-500" /> {t('pack.title')}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {options.map(opt => {
          const active = (selected || null) === (opt.id || null);
          const disabled = opt.units > available;
          const unitPrice = opt.price / opt.units;
          return (
            <button
              key={opt.id || 'unit'}
              type="button"
              disabled={disabled}
              data-testid={`pack-option-${opt.id || 'unit'}`}
              onClick={() => onSelect(opt.id || null)}
              className={`text-left rounded-lg border-2 px-4 py-3 transition-colors ${active ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-300 bg-white'} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-gray-900">{opt.id ? opt.label : t('common.unit')}</span>
                {opt.saving > 0 && <span className="text-[11px] font-bold text-white bg-green-600 px-2 py-0.5 rounded-full" data-testid={`pack-saving-${opt.id}`}>−{opt.saving} %</span>}
              </div>
              <p className="text-lg font-bold text-gray-900 mt-0.5">{opt.price.toFixed(2)} €</p>
              <p className="text-xs text-gray-500">{opt.units > 1 ? t('pack.units', { n: opt.units, price: unitPrice.toFixed(2) }) : t('pack.unitPrice')}{disabled ? t('pack.insufficient') : ''}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PackSelector;
